import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import mask from '@alpinejs/mask'
import persist from '@alpinejs/persist'

// Components
import './alpine/element--add.js'
import './alpine/accordion.js'
import './alpine/filter.js'
import './alpine/navigation.js'

// Initialise alpine plugins
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(mask)
Alpine.plugin(persist)
window.Alpine = Alpine

// Initialise alpine
Alpine.start()

// Open Offsite Links and PDFs in New Tab
let links = [...document.links].forEach((link) => {
    if (link.hostname != window.location.hostname) {
        link.target = '_blank'
    }
})
